var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transparency_nav second_font"},[_c('ul',_vm._l((_vm.types),function(type){return _c('li',{key:type.text,class:{ active: type.value === _vm.selectedType.value },on:{"click":function($event){_vm.selectedType = { ...type }}}},[_vm._v("\n            "+_vm._s(type.text)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }